import ErrorIcon from '@mui/icons-material/Error';
import WarningIcon from '@mui/icons-material/Warning';
import { Grid, Typography } from '@mui/material';
import { isEmpty, map } from 'lodash';
import React, { FunctionComponent } from 'react';

export const ManifestErrors: FunctionComponent<{ messages: string[] }> = ({ messages }) =>
  isEmpty(messages) ? null : (
    <Grid container direction="row">
      <Grid item>
        <ErrorIcon color="error" />
      </Grid>
      <Grid item xs={true} container direction="row" spacing={1}>
        <Grid item>
          <Typography>Errors:</Typography>
        </Grid>
        <Grid item>
          {map(messages, (message, index) => (
            <Typography color="error" key={index}>
              {message}
            </Typography>
          ))}
        </Grid>
      </Grid>
    </Grid>
  );

export const ManifestWarnings: FunctionComponent<{ messages: string[] }> = ({ messages }) =>
  isEmpty(messages) ? null : (
    <Grid container direction="row">
      <Grid item>
        <WarningIcon color="warning" />
      </Grid>
      <Grid item xs={true} container direction="row" spacing={1}>
        <Grid item>
          <Typography color="warning">Warnings: </Typography>
        </Grid>
        <Grid item>
          {map(messages, (message, index) => (
            <Typography key={index} color="warning">
              {message}
            </Typography>
          ))}
        </Grid>
      </Grid>
    </Grid>
  );
